import React, { FC } from 'react';
import InternalContainer from 'components/internal-container/internal-container';
import Button from 'components/Button';

interface ButtonGroupProps {
  onClickCancel: () => void;
  onClickFoward?: () => void;
  label: { backButton?: string; fowardButton: string };
  justify:
    | 'flex-end'
    | 'flex-start'
    | 'center'
    | 'space-between'
    | 'space-around';
  icon?: boolean;
  containerWidth?: string;
  valid?: boolean;
  buttonRadius?: number;
  buttonPadding?: string;
}

const ButtonGroup: FC<ButtonGroupProps> = ({
  onClickCancel,
  onClickFoward,
  label,
  justify,
  icon,
  containerWidth,
  valid,
  buttonRadius,
  buttonPadding
}) => {
  return (
    <InternalContainer width={containerWidth} justify={justify}>
      <Button
        onClick={onClickCancel}
        border="2px solid #4A90E2"
        radius={buttonRadius || 24}
        maxWidth={102}
        padding={buttonPadding || "8px 24px"}
        textColor="#4A90E2"
        backgroundColor="white"
        title={label.backButton || ''}
      />
      <Button
        onClick={onClickFoward}
        radius={buttonRadius || 24}
        maxWidth={102}
        padding={buttonPadding || "8px 24px"}
        title={label.fowardButton}
        marginLeft="24px"
        icon={icon}
        type="submit"
        disabled={valid && label.fowardButton === 'Criar campanha'}
      />
    </InternalContainer>
  );
};

export default ButtonGroup;
